import { getLabel } from "../../tools/Dictionary";

const VariableDesignerValidation = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const OnCloseModal = props.OnCloseModal;
  const Validation = props.Validation;

  console.log(Validation);

  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("variableValidator", "Error(s) during validation")}
        </div>
        <div className="page_modal_body_cont">
          <div className="variabledesigner_validation_title">
            
            {getLabel("variableValidator", "You have to solve those errors before saving your modification.")}
          </div>
          {Validation.map((v, index) => (
            <div className="variabledesigner_validation_message" key={index}>
              {getLabel("variableValidator", v.code, v.parameter)}
            </div>
          ))}
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(!OnCloseModal) ? undefined : OnCloseModal}
          />
        </div>
      </div>
    </div>
  );

};

export default VariableDesignerValidation